import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=3ef9c04a&"
import script from "./SurveyComponent.vue?vue&type=script&lang=js&"
export * from "./SurveyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports